import React, {useEffect, useState} from 'react';
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Dropdown from "react-bootstrap/Dropdown";
import Container from "react-bootstrap/Container";
import {NavLink, useHistory, useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import FeatherIcon from "feather-icons-react";
import axios from 'axios';
import LogoIcon from "../images/senzA.png";
import Avatar from "../images/avatar.png"
import {
  getName,
  getUserId, hasCashFlowPermission,
  hasDailyUpdatePermission, hasSettingsPermission,
  hasSmartFarmPermission,
  signOut
} from "../shared/authentication/authentication";
import {toggleChangePassword} from "../shared/actions/setting";
import {VIEW,MODULE} from "../shared/util/enum";
import {getSelectedFarmModule, getSelectedUserModule} from "../shared/actions/module";
import {formatDisplayEnumValueNotification, getModule} from "../shared/util/utils";
import Logo from "../images/SAlogo.png";
import {getSelectedDepartment} from "../actions/department";

const MainNavBar = (props) => {
  const [dropDown, setDropDown] = useState(false);
  const [dropDownNotification, setDropDownNotification] = useState(false);
  const [sideMenu, setSideMenu] = useState(false);
  const [module, setModule] = useState(MODULE.SMART_FARM);
  const [loadNotifications, setloadNotifications] = useState([]);
  const [isNotificationExpand, setisNotificationExpand] = useState(false);
  const [notificationID, setnotificationID] = useState(false);
  const [notificationUpdateRefresh, setnotificationUpdateRefresh] = useState(false);
  const [justInupdate, setjustInupdate] = useState(false);
  const [notificationCount, setnotificationCount] = useState();
  const [isLoading, setisLoading] = useState(false);
  const [notificationToggle, setnotificationToggle] = useState(false);

  const toggle = () => {
    if(dropDownNotification){
      setDropDownNotification(false);
    }else{
      setDropDownNotification(true);
    }
  }
  let history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const view = useSelector(state => {
    return state.setting.view
  });
  const userModules = useSelector(state => {
    return state.modules.enabledModules;
  });

  function logOut() {
    signOut();
    history.push('/login');
  }

  function setting() {
      history.push('/settings');

  }

  function systemSetting() {
      history.push('/system-config');

  }

  function goToHome() {
      history.push("/");
  }

  function goTo(module) {
    setSideMenu(false);
    history.push("/" + module);
  }


  function showChangePassword() {
    setSideMenu(false);
    dispatch(toggleChangePassword(true));
    if (view === VIEW.DEPT_LIST) {
      dispatch(getSelectedDepartment({}));
    }
  }
  function removeNotificationBadge(){
    setjustInupdate(false);
      setnotificationUpdateRefresh(!notificationUpdateRefresh);
    }

  function clickArrowDown() {
    setDropDown(true);
  }

  function clickArrowUp() {
    setDropDown(false);
  }

  function updateSeenStatus(notificationId) {

    // axios.put(process.env.REACT_APP_HOST + `/user/` + getUserId() + `/notification/` + notificationId)
    //   .then(res => {
    //   })
    //   .catch(error => {
    //     if (error.response && error.response.status === 422) {
    //       console.log(error.response.data.message);
    //     }
    //   })
    //   .finally(() => {
    //   });
  }

  function toggleNotificationTruncate(value, notificationId, notificationsseenStatus) {
    setisNotificationExpand(value);
    setnotificationID(notificationId);

    if (value && !notificationsseenStatus) {
      updateSeenStatus(notificationId);

    }
    if (!value && !notificationsseenStatus) {
      setnotificationUpdateRefresh(!notificationUpdateRefresh);
    }
  }

  useEffect(()=>{
    setisLoading(true);
    axios.get(process.env.REACT_APP_HOST + `/user/` + getUserId() + `/moduleConfig`)
        .then(res => {
          dispatch(getSelectedUserModule(res.data.content.enabledModules));
          dispatch(getSelectedFarmModule(res.data.content.farmModules));
        })
        .finally(() => {
          setisLoading(false);
        });
  },[]);

  useEffect(()=> {
    let count = 0;
    loadNotifications.map((item) => {
      if (!item.seenStatus) {
        count += 1;
      }
      else
      {
        localStorage.removeItem(item.id,item.id);
      }
      if(!item.seenStatus && !localStorage.getItem(item.id)){
        setjustInupdate(true);
        if(isLoading && notificationToggle){
          setjustInupdate(false);
          localStorage.setItem(item.id,item.id);
          updateSeenStatus(item.id);
        }
      }
    }
    );
    setisLoading(false);
    setnotificationCount(loadNotifications.length - count);
  },[isLoading]);

  function onPaths(paths) {
    return (match, location) => {
      if (paths === "SF") {
        return !location.pathname.match("/employee") && !location.pathname.match("/manualEntry") && !location.pathname.match("/jobDetails") && !location.pathname.match("/settings") && !location.pathname.match("/xindicate");
      }
      return location.pathname.match(paths);
    };
  }

  useEffect(() => {
    setModule(getModule(location.pathname));
  }, [location]);

  // useEffect(() => {
  //
  //   axios.get(process.env.REACT_APP_HOST + `/user/` + getUserId() + `/notifications`)
  //     .then(res => {
  //       setloadNotifications(res.data.content);
  //       setisLoading(true);
  //     })
  //     .finally(() => {
  //       setisLoading(false);
  //     });
  // }, [notificationUpdateRefresh]);

  return  (!sideMenu ?
    <Navbar className={"sm-navbar"} expand="md">
      <Container className={"sa-navbar-container"}>
        {/*<Navbar.Toggle aria-controls="basic-navbar-nav" />*/}
        <Navbar.Brand>
          <img onClick={()=>{goToHome()}} className="sa-logo-varna" src={Logo} alt="logo"/>
        </Navbar.Brand>
        <Navbar id="responsive-navbar-nav">
          <Nav className="mr-auto collapse-navbar navbar-top">
            {hasSmartFarmPermission() && <NavLink  to={'/'} isActive={onPaths("SF")} activeClassName="nav-active">MACHINE PERFORMANCE</NavLink>}
            {hasDailyUpdatePermission() && <NavLink to={'/employee'} isActive={onPaths("/employee")} activeClassName="nav-active">EMPLOYEE PERFORMANCE</NavLink>}
            {hasCashFlowPermission() && <NavLink  to={'/manualEntry'} isActive={onPaths("/manualEntry")} activeClassName="nav-active">MANUAL ENTRY</NavLink>}
            {hasCashFlowPermission() && <NavLink  to={'/jobDetails'} isActive={onPaths("/jobDetails")} activeClassName="nav-active">JOB DETAILS</NavLink>}
          </Nav>
        </Navbar>
        {/*<Dropdown show={dropDownNotification} onToggle={toggle} alignRight>*/}
        {/*  <Dropdown.Toggle id="dropdown-custom-components" >*/}
        {/*    <div onClick={()=>{removeNotificationBadge();setisLoading(true);  setnotificationToggle(true)}}>*/}
        {/*      <FeatherIcon className={dropDownNotification ? "bell-icon-b bell-icon-bb": "bell-icon-b"} icon="bell" />*/}
        {/*      {dropDownNotification ? <div onClick={clickArrowUp.bind(this)} className="bell-icon text-black"></div> :*/}
        {/*        <div onClick={clickArrowDown.bind(this)} className="bell-icon"></div>*/}
        {/*      }*/}
        {/*      {justInupdate &&*/}
        {/*        <div className={"circle-icon-overlap"}>*/}
        {/*          <FeatherIcon className="circle-in" icon="circle" />*/}
        {/*        </div>}*/}
        {/*    </div>*/}
        {/*  </Dropdown.Toggle>*/}
        {/*  <Dropdown.Menu id={"dropdown-notification"}>*/}
        {/*          <div className="single-card-content-nf ">*/}
        {/*            <div className="notification-text">NOTIFICATIONS</div>*/}
        {/*            {notificationCount > 0 &&*/}
        {/*            <div className="update-text">Just in Update </div>*/}
        {/*            }*/}

        {/*            <div className="row">*/}
        {/*        <div className="col-12" >*/}
        {/*          {loadNotifications.length > 0 &&*/}
        {/*            loadNotifications.map((notifications) => (*/}
        {/*              ((notifications.seenStatus === false) &&*/}
        {/*                <div key={notifications.id}>*/}
        {/*                <div className="nf-details">*/}
        {/*                  <div className="senz-icon-nf"><img src={LogoIcon} /></div>*/}
        {/*                  <div className="nf-data">*/}
        {/*                    <div key={notifications.id} className="nf-Name1 limit-chara-nf">{formatDisplayEnumValueNotification(notifications.title)}</div>*/}
        {/*                    <div className={(notificationID === notifications.id) ? "nf-Name2 limit-chara-nfff" : "nf-Name2 limit-chara-nff"} >{notifications.message}</div>*/}
        {/*                    {isNotificationExpand && (notificationID === notifications.id) ?*/}
        {/*                      <button className="pull-right button-ellipsis" onClick={() => toggleNotificationTruncate(false, null, notifications.seenStatus)} >-Less</button> :*/}
        {/*                      <button className="pull-right button-ellipsis" onClick={() => toggleNotificationTruncate(true, notifications.id, notifications.seenStatus)} >-More</button>}*/}
        {/*                  </div>*/}
        {/*                </div>*/}
        {/*              </div>)*/}
        {/*            ))}*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*      <div className="row">*/}
        {/*        <div className="col-12">*/}
        {/*          {notificationCount > 0 &&*/}
        {/*          <div className="update-text-previous-notification">Previous Notification ({notificationCount})</div>*/}
        {/*        }*/}

        {/*          {loadNotifications.length === 0 && (*/}
        {/*              <div className={"empty-results-notification"}>*/}
        {/*                <FeatherIcon icon="info"/>*/}
        {/*                <div className={"empty-results-text-nf"}>There are no notifications</div>*/}
        {/*              </div>)*/}
        {/*          }*/}
        {/*          {loadNotifications.length > 0 &&*/}

        {/*            loadNotifications.map((notifications) => (*/}
        {/*              ((notifications.seenStatus === true) &&*/}
        {/*                <div key={notifications.id}>*/}
        {/*                <div className="nf-details">*/}
        {/*                  <div className="senz-icon-nf"><img src={LogoIcon} /></div>*/}
        {/*                  <div className="nf-data">*/}
        {/*                    <div key={notifications.id} className="nf-Name1 limit-chara-nf">{formatDisplayEnumValueNotification(notifications.title)}</div>*/}
        {/*                    <div className={(notificationID === notifications.id) ? "nf-Name2 limit-chara-nfff" : "nf-Name2 limit-chara-nff"} >{notifications.message}</div>*/}
        {/*                    {isNotificationExpand && (notificationID === notifications.id) ?*/}
        {/*                      <button className="pull-right button-ellipsis" onClick={() => toggleNotificationTruncate(false, null, notifications.seenStatus)} >-Less</button> :*/}
        {/*                      <button className="pull-right button-ellipsis" onClick={() => toggleNotificationTruncate(true, notifications.id, notifications.seenStatus)} >-More</button>}*/}
        {/*                  </div>*/}
        {/*                </div>*/}
        {/*              </div>*/}
        {/*              )*/}
        {/*            ))}*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </Dropdown.Menu>*/}
        {/*      </Dropdown>*/}
        <div className='d-flex flex-row align-items-center'>
          <Dropdown id={"profileDropdown"} alignRight>
            <Dropdown.Toggle id="dropdown-custom-components">
              <div className="user-profile-factoryspy ">
                <div className="user-profile-inner">
                  <img className="user-profile-image profile-center" src={Avatar}
                      alt="profile"/>
                </div>
              </div>
              <span className={"mobile-hide"} id={"profileName"}>{getName()}</span>
            </Dropdown.Toggle>
          </Dropdown>
          <Dropdown id={"profileDropdown"} alignRight>
            <Dropdown.Toggle id="dropdown-custom-components">
              {dropDown ? <div onClick={clickArrowUp.bind(this)} className="dropdown-icon "><i className="fa fa-angle-down"/></div> :
                  <div onClick={clickArrowDown.bind(this)} className="dropdown-icon "><i className="fa fa-angle-down"/></div>
              }
            </Dropdown.Toggle>
            <Dropdown.Menu style={{marginTop:8, marginRight:-5}}>
              <Dropdown.Item>About FactorySpy</Dropdown.Item>
                {/*{hasSettingsPermission() &&*/}
                {/*<Dropdown.Item onClick={setting}>Settings</Dropdown.Item>*/}
                {/*}*/}
                {/*{hasSettingsPermission() &&*/}
                {/*<Dropdown.Item onClick={systemSetting}>System Settings</Dropdown.Item>*/}
                {/*}*/}
              <Dropdown.Item onClick={showChangePassword}>Change Password</Dropdown.Item>
              <Dropdown.Item onClick={logOut}>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <FeatherIcon onClick={()=> setSideMenu(true)} className={"side-menu-btn"} icon="menu"/>
        </div>
      </Container>
    </Navbar> :
      <div className={"side-nav-container"}>
        <FeatherIcon onClick={()=> setSideMenu(false)} className={"side-menu-close-btn"} icon="x"/>
        <div className="user-profile">
          <div className="user-profile-inner">
            <img className="user-profile-image profile-center" src={Avatar} alt="profile"/>
          </div>
        </div>
        <div className={"side-menu-name"}>{getName()}</div>
        {hasSmartFarmPermission() &&
        <div onClick={() => goTo("home")} className={"side-menu-nav " + (location.pathname === "/home" ? "nav-active-mv" : "")}>
            <FeatherIcon className={"side-menu-nav-icon"} icon="book-open"/> 
            <span className={"m-l-10"}>MACHINE PERFORMANCE</span>
        </div>
        }
        {hasDailyUpdatePermission() &&
        <div onClick={() => goTo("employee")} className={"side-menu-nav " + (location.pathname === "/employee" ? "nav-active-mv" : "")}>
            <FeatherIcon className={"side-menu-nav-icon"} icon="check-square"/> 
            <span className={"m-l-10"}>EMPLOYEE PERFORMANCE</span>
        </div>
        }
        {hasCashFlowPermission() &&
        <div onClick={() => goTo("manualEntry")} className={"side-menu-nav " + (location.pathname === "/manualEntry" ? "nav-active-mv" : "")}>
            <FeatherIcon className={"side-menu-nav-icon"} icon="file"/>
            <span className={"m-l-10"}>MANUAL ENTRY</span>
        </div>
        }
        {hasCashFlowPermission() &&
        <div onClick={() => goTo("jobDetails")} className={"side-menu-nav " + (location.pathname === "/jobDetails" ? "nav-active-mv" : "")}>
            <FeatherIcon className={"side-menu-nav-icon"} icon="clipboard"/>
            <span className={"m-l-10"}>JOB DETAILS</span>
        </div>
        }
        {hasSettingsPermission() &&
        <div  onClick={()=>goTo("settings")} className={"side-menu-nav " + (module===MODULE.SETTINGS ? "nav-active-mv" : "")}><FeatherIcon
          className={"side-menu-nav-icon"} icon="settings"/> <span className={"m-l-10"}>Settings</span>
        </div>
        }
        <div className={"side-menu-footer"}>
          <div className={"side-menu-nav"}><FeatherIcon className={"side-menu-nav-icon"} icon="alert-circle"/> <span className={"m-l-10"}>About SenzMate</span></div>
          <div className={"side-menu-nav"} onClick={showChangePassword}><FeatherIcon className={"side-menu-nav-icon"} icon="lock"/> <span className={"m-l-10"}>Change Password</span></div>
          <div className={"side-menu-nav"} onClick={logOut}><FeatherIcon className={"side-menu-nav-icon"} icon="log-out"/> <span className={"m-l-10"}>Logout</span></div>
        </div>
      </div>);
};

export default MainNavBar
